export const MobileType = {
	IOS: "IOS",
	ANDROID: "ANDROID",
};

export const APP_PERMISSION = {
	CAMERA: "android.permission.CAMERA",
};

export const Platform = {
	ANDROID: "ANDROID",
	IOS: "IOS",
	ANDROID_WAP: "ANDROID_WAP",
	IOS_WAP: "IOS_WAP",
	WEB: "WEB",
};

export const NativeRequestType = {
	GET_HEADERS: "GET_HEADERS",
	UPDATE_HEADER_FOOTER: "UPDATE_HEADER_FOOTER",
	BACK_BUTTON_CLICKED: "BACK_BUTTON_CLICKED",
	GET_SESSION_ID: "GET_SESSION_ID",
	MARK_MOENGAGE_EVENT: "MARK_MOENGAGE_EVENT",
	GET_DENSITY: "GET_DENSITY",
	CLOSE_WEB_VIEW: "CLOSE_WEB_VIEW",
	GET_MOBILE_NUMBER: "GET_MOBILE_NUMBER",
	BRANCH_INTEGRATION_EVENT: "BRANCH_INTEGRATION_EVENT",
};

export const ACCESS_TOKEN_KEY = "access-token";

export const SessionStorageKeys = {
	AppVersion: "AppVersion",
	VisitorId: "VisitorId",
};

export const ENVIRONMENT = {
	PROD: "PROD",
	STAGE: "STAGE",
	DEV: "DEV",
	QA_PROD: "QA_PROD",
	QA_STAGE: "QA_STAGE",
};

export const ClickStreamPlatform = {
	WEB_VIEW: "webview",
	M_WEB: "mweb",
};

export const ClickStreamEventActions = {
	click: "click",
	impression: "impression",
	pageOpen: "pageopen",
	error: "error",
	pageClose: "pageclose",
	pageloaded: "pageloaded",
	pageInview: "pageinview",
	pageOutview: "pageoutview",
	pageError: "pageError",
	bottomNav: "bottom nav click",
	dismiss: "dismiss",
	scroll: "On Scroll",
	mapdrag: "mapdrag",
};
